import { render, staticRenderFns } from "./AuthorizeUser.vue?vue&type=template&id=9fb2345c&scoped=true"
import script from "./AuthorizeUser.vue?vue&type=script&lang=js"
export * from "./AuthorizeUser.vue?vue&type=script&lang=js"
import style0 from "./AuthorizeUser.vue?vue&type=style&index=0&id=9fb2345c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb2345c",
  null
  
)

export default component.exports